<template>
    <div>
        <b-navbar id="respNav" type="dark" variant="info" fixed="top" >
            <b-navbar-brand tag="h1">BootstrapVue</b-navbar-brand>

            <b-navbar-nav id="dropSelector">
                <b-nav-item-dropdown text="Lang con descrizione lunga" >
                    <b-dropdown-item href="#">EN</b-dropdown-item>
                    <b-dropdown-item href="#">ES</b-dropdown-item>
                    <b-dropdown-item href="#">RU</b-dropdown-item>
                    <b-dropdown-item href="#">FA</b-dropdown-item>
                </b-nav-item-dropdown>
            </b-navbar-nav>

            <b-navbar-nav class="ml-auto">
                <b-nav-item href="#">Link</b-nav-item>
                <b-nav-item href="#" disabled>Disabled</b-nav-item>
            </b-navbar-nav>
            
            
        </b-navbar>
        <b-container style="margin-top: 80px">
            <b-row>
            <b-col>
                <panZoom :options="{minZoom: 1.0, maxZoom: 5, bounds: true, boundsPadding: 1}" @panstart="panStart" @pan="pan" style="width: 500px; overflow: hidden">
                <b-img src="img/ambienti/1001-2.jpg" style="width:500px; height:auto" />
                </panZoom>
            </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h2>Test QR-Code</h2>
                    <h4>Codice letto: <strong>{{scanned}}</strong></h4>
                    <b-form-input type="text" v-model="scanned"></b-form-input>
                    <b-button variant="primary" @click="startScan">Scansiona</b-button>
                    <qrcode-stream v-if="scanning || initialized" @decode="onDecode" @init="onInit" v-bind:style="{height: '300px', display: (scanning)?'inline':'none'}"></qrcode-stream>
                </b-col>
            </b-row>
        </b-container>
        <hide-at :breakpoints="{small: 420, medium: 768, large: 1024}" breakpoint="mediumAndAbove">
            <b-row id="bottomNavBar" class="fixed-bottom mx-0 px-0 text-center">
                    <b-col cols="3" ><i class="fa fa-address-card-o fa-lg"></i><br/>Overview</b-col>
                    <b-col cols="3" ><i class="fa fa-snowflake-o fa-lg"></i><br/>Dispositivi</b-col>
                    <b-col cols="3" ><i class="fa fa-user-circle-o fa-lg"></i><br/>Test Pianificati</b-col>
                    <b-col cols="3" ><i class="fa fa-bars fa-lg"></i><br/>Altro</b-col>
            </b-row>
        </hide-at>
    </div>
</template>

<script>
import Vue from 'vue'
import {showAt, hideAt} from 'vue-breakpoints'
import {QrcodeStream} from "vue-qrcode-reader";

import panZoom from 'vue-panzoom'
Vue.use(panZoom);

export default {
    name: 'TestResponsive',
    components: {
        hideAt, showAt, QrcodeStream
    },
    data() {
        return {
            scanned: 'nessun codice letto',
            scanning: false,
            initialized: false
        }
    },
    methods: {
        pan(srcObj) {
            //console.log("pan",srcObj.getTransform());
            var tr = srcObj.getTransform();
            if (tr.scale == 1) return false;
        },
        panStart(e) {
            console.log("panstart!",e);
        },
        onDecode(decodedString) {
            console.log("codeScanned:",decodedString);
          this.scanned = decodedString;
          //setTimeout(function() {
            this.scanning = false;
          //},2000);
          
        },
        async onInit(promise) {
            try {
                await promise;
                this.initialized = true;
            } catch (error) {
                console.log("error on init", error);
                this.scanned = "" + error;
            }
        },
        async startScan() {
            if (this.initialized) {
                this.initialized = false;
                await this.$nextTick();
                
            }
            this.scanned = ''
            this.scanning = true;
        }
    }
}
</script>

<style lang="scss">

    nav#respNav {
        background-color: #f00 !important;
    }

    #bottomNavBar {
        height: 56px;
        background-color: #0Cf;
        font-size: 9pt;
        color: #fff;

        i {
            font-size: 32px;
            margin-top: 10px;
            margin-bottom: 4px
        }
    }
    
    @media screen and (min-width: 420px){
        nav#respNav {
            background-color: #0f0 !important;

            
        }
    }

    @media screen and (max-width: 419px) {

        

        ul#dropSelector {
            background-color: #f00 !important;
            display: block;
            margin-top: 40px;
            float: left;
            position: absolute;
            margin-left: 0px;
            left: 0px;
            width: 100%;
            
        }
    }
    
    
</style>